import React, {useState, useRef, useEffect} from 'react';
import { Modal } from 'react-bootstrap';
import closeicon from '../Images/close.png';
import imageicon from '../Images/gallery.png';
import videoicon from '../Images/video.png';
import gificon from '../Images/gif-file.png';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import { Bounce } from "react-activity";
import "react-activity/dist/library.css";
import { connect } from 'react-redux';
import Resizer from 'react-image-file-resizer'


const CreatePostModal = ({isCreatePostModalVisible, setIsCreatePostModalVisible, currentUser}) => {
  const[title, setTitle] = useState('');
  const[message, setMessage] = useState('');
  const[image, setImage] = useState(null);
  const[imageUrl, setImageUrl] = useState(null);
  const[fileType, setFileType] = useState('');
  const[hideVideo, setVideo] = useState('hidden');
  const[isUploading, setIsUploading] = useState(false);
  const [fileName, setFileName] = useState('');


  const fileInputRef = useRef(null)

  const changeText = (event) => {
    setTitle(event.target.value);
  }
  const changeMessage = (event) => {
    setMessage(event.target.value)
  }

  const convertToWebP = async (image) => {
    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        image,
        image.width,
        image.height,
        'WEBP',
        100,
        0,
        (uri) => {
          const byteString = atob(uri.split(',')[1]);
          const mimeString = uri.split(',')[0].split(':')[1].split(';')[0];
          const arrayBuffer = new ArrayBuffer(byteString.length);
          const intArray = new Uint8Array(arrayBuffer);
  
          for (let i = 0; i < byteString.length; i++) {
            intArray[i] = byteString.charCodeAt(i);
          }
  
          const blob = new Blob([arrayBuffer], { type: mimeString });
  
          const webpFile = new File([blob], `${image.name.split('.')[0]}.webp`, { type: 'image/webp' });
  
          resolve(webpFile);
        },
        'base64'
      );
    });
  }

  const handleFileChange = (event) => {
    if (event.target.files[0]) {
      const selectedImage = event.target.files[0]
      const fileType = selectedImage.name.split('.').pop().toLowerCase();
      setFileType(fileType);
      setImage(selectedImage);
      setImageUrl(URL.createObjectURL(selectedImage));
      setFileName(selectedImage.name);
    }
  }

  const handleButtonClick = () => {
    fileInputRef.current.click();
  }

  useEffect(() => {
    if(fileType === 'mp4') {
      setVideo('not-hidden')
    }
    if(fileType === 'mov') {
      setVideo('not-hidden')
    }
  },[fileType])

  const handleUpload = async () => {
    setIsUploading(true)
    const webpImage = await convertToWebP(image);
    const uploadTask = firebase.storage().ref(`/images/${webpImage.name}`).put(webpImage)
    uploadTask.on('state_changed', 
    (snapShot) => {
      console.log(snapShot)
    }, (err) => {
      console.log(err)
    }, async () => {
      firebase.storage().ref('images').child(webpImage.name).getDownloadURL()
       .then(fireBaseUrl => {
        savePostData(fireBaseUrl)
       })
    })
  }

  const savePostData = (downloadURL) => {
    setIsUploading(true)
    const posterId = firebase.auth().currentUser.uid
    const likes = 0
    const saves = 0
    const shares = 0
    firebase.firestore()
    .collection('posts')
    .doc(firebase.auth().currentUser.uid)
    .collection('userPosts')
    .add({
      posterId,
      title,
      downloadURL,
      message,
      likes,
      saves,
      shares,
      posterName: currentUser.name,
      creation: firebase.firestore.FieldValue.serverTimestamp()
    }).then((function () {
      setIsUploading(false)
      window.location = '/'
    }))
}
  return (
    <div>
      <Modal show={isCreatePostModalVisible} onHide={() => {setIsCreatePostModalVisible(false)}} className='create-post-modal'>       
          <Modal.Body className='create-post-modal-body'>  
            <div className='modal-outer create-post-modal-outer'>
              <div className="close-icon-div">
                <img src={closeicon} alt="Close Icon" onClick={() => setIsCreatePostModalVisible(false)} className="close-icon"></img>
              </div>
              <div className="modal-inner create-post-modal-inner">
                <div className='create-post-inner-div'>
                  <input placeholder='Title (optional)' type='text' className='create-post-title-input' value={title} onChange={changeText}></input>
                  
                  <div className='textarea-div'>
                    <textarea placeholder='Message (optional)' type='text' className='create-post-message-input' value={message} onChange={changeMessage} rows={8}></textarea>
                  </div>
                  
                  {/* <input type='file' ref={fileInputRef} style={{display: 'none'}} onChange={handleFileChange} accept="image/*, video/*, gif/*, image/png, image/jpg, image/gif, image/jpeg"></input> */}
                  <input type='file' ref={fileInputRef} style={{display: 'none'}} onChange={handleFileChange} accept="image/*, gif/*, image/png, image/jpg, image/gif, image/jpeg"></input>

                  {image && (
                    <>
                      {fileType === 'jpg' || fileType === 'jpeg' || fileType === 'png' || fileType === 'gif' ? (
                        <img src={imageUrl} alt='Selected' style={{maxHeight: '400px', maxWidth: '100%'}} />
                        ) : fileType === 'mp4' ? (
                        <video src={imageUrl} controls style={{maxHeight: '400px', maxWidth: '100%'}} className={`${hideVideo}`} />
                        ) : fileType === 'mov' ? (
                          <video src={imageUrl} controls style={{maxHeight: '400px', maxWidth: '100%'}} className={`${hideVideo}`} />
                          ) : null
                      }
                    </>
                  )}
              
                  {image && <p className='file-name'>{fileName}</p>}

                  {isUploading && <div className='loader'><Bounce className='bounce'/></div>}

                  <div className='gallery-buttons-div'>
                    <button onClick={handleButtonClick} className='file-button'>
                      <img src={imageicon} alt='Gallery Icon' className='image-icon'></img>
                    </button>
                    <button /* onClick={handleButtonClick} */ className='file-button' onClick={() => alert('Video upload not supported yet')}>
                      <img src={videoicon} alt='Gallery Icon' className='video-icon'></img>
                    </button>
                    <button onClick={handleButtonClick} className='file-button'>
                      <img src={gificon} alt='Gallery Icon' className='video-icon'></img>
                    </button>
                  </div> 
                </div>
              </div>
            </div>
            <div className='create-post-modal-footer'>
              {(message === '' && image === null) ? 
              <button disabled className='post-button'>Post</button> : 
              message !== '' ? <button onClick={() => (image) ? handleUpload() : savePostData('')} className='post-button'>Post</button> : 
              image !== null ? <button onClick={() => (image) ? handleUpload() : savePostData('')} className='post-button'>Post</button> : 
              null}
            </div>
          </Modal.Body>  
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUser
  }
}

export default connect(mapStateToProps)(CreatePostModal)